/**
 * "Open this program's builder" intent, carried from a co-design invite
 * (email / Teams deep link `…#/app/redirect?openProgram=<id>`, or the in-app
 * bell item) to the admin dashboard, which runs that program card's Continue.
 *
 * Kept in sessionStorage because the deep link can pass through the Auth0 login
 * redirect and RoleRedirect's <Navigate>, both of which drop the query string.
 */
const KEY = 'dosen:openProgram';
const OBJECT_ID = /^[a-f\d]{24}$/i;

export const setOpenProgramIntent = (programId: string) => {
  if (!OBJECT_ID.test(programId)) return;
  try {
    sessionStorage.setItem(KEY, programId);
  } catch {
    /* storage unavailable — the dashboard just won't auto-open */
  }
};

/** Call once at app boot: stash ?openProgram= from the landing URL (hash router). */
export const captureOpenProgramIntent = () => {
  try {
    const query = window.location.hash.split('?')[1] || window.location.search.replace(/^\?/, '');
    const id = new URLSearchParams(query).get('openProgram');
    if (id) setOpenProgramIntent(id);
  } catch {
    /* ignore malformed URLs */
  }
};

/** Read and clear — the dashboard consumes it once. */
export const takeOpenProgramIntent = (): string | null => {
  try {
    const id = sessionStorage.getItem(KEY);
    if (id) sessionStorage.removeItem(KEY);
    return id;
  } catch {
    return null;
  }
};

export const peekOpenProgramIntent = (): string | null => {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
};
